import { API_ASDI_CMS_BASE_URL } from 'config/constants'
import fetchHelper from 'library/FetchHelper'
import { useCallback } from 'react'
import useGetNotification from './useGetNotification'

const usePutReadAllNotification = () => {
  const [getNotification] = useGetNotification(false)

  const putData = useCallback(
    (cbs?: any, cbe?: any) => {
      try {
        fetchHelper
          .fetch(`${API_ASDI_CMS_BASE_URL}/notification/read/all`, {
            method: 'PUT',
          })
          .then(([resp, status]: any) => {
            if (status === 200) {
              if (cbs) cbs(resp.data)
              getNotification()
            } else if (cbe) cbe(resp)
          })
      } catch (error) {
        console.error('usePutReadAllNotification', error)
      }
    },
    [getNotification],
  )

  return [putData]
}

export default usePutReadAllNotification
